<template>
  <div v-if="!isEmpty" class="finder" :style="{height: height + 'px'}" ref="finderDom">
    <div class="finder-inner" :style="{width: `${containerWidth}%`}">
      <finderframe
        v-for="(frame, index) in frames"
        v-on:click="childClicked"
        :class="frameClasses"
        :index="index"
        :label="frame.label"
        :children="frame.children"
        :active-child="frame.activeChild"
        :is-last="index + 1 == frames.length"
        :height="height"
      ></finderframe>
    </div>
  </div>
</template>
<script>
import FinderFrame from './FinderFrame.vue';

export default {
  components: {
    finderframe: FinderFrame
  },
  props: {
    tree: {
      type: Object
    },
    selection: {
      type: Array,
      default() {
        return [];
      }
    },
    framesTest: {
      type: Array,
      default() {
        return [];
      }
    },
    height: {
      type: Number,
      default: 400
    },
    frameClasses: {},
    maxCols: {
      type: Number,
      default: 3
    }
  },
  mounted(){
    this.autoScroll();
  },
  updated(){ 
    this.autoScroll();
  },
  computed: {
    containerWidth() {
      return frames.length > this.maxCols ? Math.round(100 / this.maxCols) * frames.length + 1 : 100;
    },
    isEmpty() {return !this.tree; },
    frames() {
      if (!this.tree) {
        return [];
      }
      var frames = [ this.tree ],
          branch = this.tree;

      for (var i = 0 ; i < this.selection.length ; i++) {
        branch.activeChild = this.selection[i];
        branch = branch.children[this.selection[i]];
        if (!branch) {
          break;
        }
        if (typeof branch.children == 'object') {
          branch.activeChild = null;
          frames.push(branch);
        }
      }

      return frames;
    }
  },
  methods: {
    childClicked(child, index, key) {
      this.$emit('clickchild', child, index, key, this.addSelection);

      // this.$refs.finderDom.scrollTop = 0;
    },
    addSelection(ref, index, key) {
      ref.selection.splice(index);
      ref.selection.push(key);
    },
    autoScroll() {
      this.$refs.finderDom.scrollLeft = this.$refs.finderDom.scrollWidth;
    }
  }
};
</script>
